import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciPage,
  type SolveConfig,
  SolveForCalc,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { solvePercentWV } from "../lib/percent-solution";

const MASS_UNITS = [
  { value: "g", label: "g" },
  { value: "mg", label: "mg" },
  { value: "µg", label: "µg" },
];
const VOL_UNITS = [
  { value: "mL", label: "mL" },
  { value: "L", label: "L" },
  { value: "µL", label: "µL" },
];
const PCT_UNITS = [{ value: "pct", label: "%" }];

const config: SolveConfig = {
  resultTestId: "pctsol-result",
  hintLeaveBlank: () => m.pctsol_hint_leave_blank(),
  hintInvalid: () => m.pctsol_hint_invalid(),
  resultPrefix: () => m.sci_result_solves(),
  fields: [
    {
      id: "mass",
      label: () => m.pctsol_field_mass(),
      kind: "mass",
      units: MASS_UNITS,
      placeholder: "5",
    },
    {
      id: "volume",
      label: () => m.pctsol_field_volume(),
      kind: "volume",
      units: VOL_UNITS,
      placeholder: "100",
    },
    {
      id: "percent",
      label: () => m.pctsol_field_percent(),
      kind: "plain",
      units: PCT_UNITS,
    },
  ],
  solve: (base) => {
    const blanks = ["mass", "volume", "percent"].filter(
      (id) => base[id] === null,
    );
    if (blanks.length !== 1) return null;
    const value = solvePercentWV({
      mass: base.mass,
      volume: base.volume,
      percent: base.percent,
    });
    return value === null ? null : { id: blanks[0], value };
  },
};

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.pctsol_tool_name()}
        toolPath="/percent-solution"
      />

      <header className="mt-6 mb-8">
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
          {m.pctsol_h1()}
        </h1>
        <p className="mt-3 leading-relaxed text-muted-foreground">
          {m.pctsol_intro()}
        </p>
      </header>

      <SolveForCalc config={config} />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.pctsol_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.pctsol_ex1(), m.pctsol_ex2(), m.pctsol_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.pctsol_faq_q1(), a: m.pctsol_faq_a1() },
          { q: m.pctsol_faq_q2(), a: m.pctsol_faq_a2() },
          { q: m.pctsol_faq_q3(), a: m.pctsol_faq_a3() },
          { q: m.pctsol_faq_q4(), a: m.pctsol_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
